import styled from 'styled-components'

export const LineStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: start;
  width: 99%;
  border-bottom: 1px solid white;
  margin: 0.7em;
  .lineHeader {
    width: 200px;
  }
`
export const PropertyStyle = styled.div`
  font-weight: bold;
  padding-left: 1em;
  width: 250px;
`
